import { render, staticRenderFns } from "./CompanyDataUpdateFormFilesDetails.vue?vue&type=template&id=5f56ec47&scoped=true&"
import script from "./CompanyDataUpdateFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateFormFilesDetails.vue?vue&type=style&index=0&id=5f56ec47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56ec47",
  null
  
)

export default component.exports